export function purchasedLicenseTotal(license) {
  // Zero seats denotes a flat-price purchase, such as a domain.
  return Number(license.price_per_seat) * (Number(license.seats) || 1);
}

export function abbreviatedPersonName(person) {
  const name = (person && person.preferred_name) || {};
  const given = (name.given_name || '').trim();
  const family = (name.family_name || '').trim();
  const initial = family ? `${Array.from(family)[0].toLocaleUpperCase()}.` : '';
  return [given, initial].filter(Boolean).join(' ');
}

export function licenseRenewalStatus(license, now = new Date()) {
  if (license.renewal_type !== 'annual' || !/^\d{4}-\d{2}-\d{2}$/.test(license.renewal_date || '')) return '';
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const today = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  // Clamp month-end dates instead of letting Date roll into a third month.
  const boundary = new Date(Date.UTC(year, month + 2, 1));
  const lastDay = new Date(Date.UTC(year, month + 3, 0)).getUTCDate();
  boundary.setUTCDate(Math.min(day, lastDay));
  if (license.renewal_date < today) return 'overdue';
  return license.renewal_date < boundary.toISOString().slice(0, 10) ? 'soon' : '';
}

export function renewalPeriodEnd(license) {
  if (license.renewal_type !== 'annual' || !/^\d{4}-\d{2}-\d{2}$/.test(license.renewal_date || '')) return null;
  const [year, month, day] = license.renewal_date.split('-').map(Number);
  const lastDay = new Date(Date.UTC(year + 1, month, 0)).getUTCDate();
  return `${year + 1}-${String(month).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`;
}

export function licensePersonStatus(person, periodEnd) {
  const current = person.current_vinculations || [];
  const dates = current.map(vinculation => vinculation.end_date);
  const endDate = dates.length && !dates.includes(null) ? dates.slice().sort().pop() : null;
  return {
    ...person,
    types: [...new Set(current.map(vinculation => vinculation.type))],
    endDate,
    noCurrentVinculation: current.length === 0,
    expiresDuringPeriod: !!periodEnd && !!endDate && endDate < periodEnd
  };
}
